import { render, staticRenderFns } from "./Personalangaben.vue?vue&type=template&id=0c78c271&"
import script from "./Personalangaben.vue?vue&type=script&lang=js&"
export * from "./Personalangaben.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports